/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strong_Teal_Salmon_MendInputs */

const fr_strong_teal_salmon_mend = /** @type {(inputs: Strong_Teal_Salmon_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A venir`)
};

/**

* @param {Strong_Teal_Salmon_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const strong_teal_salmon_mend = /** @type {((inputs?: Strong_Teal_Salmon_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strong_Teal_Salmon_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_strong_teal_salmon_mend(inputs)
});